/* ============================================================
   Salty Seats - Help and user guides page behaviours.
   Tabs, YouTube facade, FAQ search/filter/accordions, the contact
   form submit, and scroll-to-contact after a form submission.
   ============================================================ */

(function () {
  'use strict';

  function youtubeId(input) {
    if (!input) return '';
    var v = input.trim();
    if (/^[\w-]{11}$/.test(v)) return v;
    var m =
      v.match(/[?&]v=([\w-]{11})/) ||
      v.match(/youtu\.be\/([\w-]{11})/) ||
      v.match(/\/embed\/([\w-]{11})/) ||
      v.match(/\/shorts\/([\w-]{11})/);
    return m ? m[1] : '';
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-sshp-tab]');
    var panels = root.querySelectorAll('[data-sshp-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-sshp-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-sshp-panel') === idx);
        });
      });
    });
  }

  function initVideos(root) {
    root.querySelectorAll('[data-sshp-video]').forEach(function (box) {
      var facade = box.querySelector('[data-sshp-play]');
      if (!facade) return;
      facade.addEventListener('click', function () {
        var id = youtubeId(box.getAttribute('data-sshp-video'));
        if (!id) return;
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        iframe.title = box.getAttribute('data-sshp-vtitle') || 'Video';
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        box.innerHTML = '';
        box.appendChild(iframe);
      });
    });
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-sshp-acc]').forEach(function (head) {
      var item = head.parentElement;
      var body = item && item.querySelector('.sshp-faq__a');
      if (!body) return;
      head.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        body.hidden = !open;
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* The FAQ engine. The search field lives up in the hero, so it is
     looked up on the page rather than inside this section - the two
     are one control in the design even though they are two sections
     in the theme.

     Cap, counts, the answer tally and the show-all toggle all follow
     the prototype: the cap only applies to the unfiltered list, since
     someone who has typed a word or picked a topic has already said
     what they want to see. */
  function initFaqFilter(root) {
    /* The section root IS the element carrying data-sshp-faq, and
       querySelector only looks at descendants - match the root first
       or the whole engine silently never starts. */
    var faq = root.matches('[data-sshp-faq]') ? root : root.querySelector('[data-sshp-faq]');
    if (!faq) return;

    var inputs = Array.prototype.slice.call(
      document.querySelectorAll('[data-sshp-search]')
    );
    var topics = Array.prototype.slice.call(faq.querySelectorAll('[data-sshp-topic]'));
    var items = Array.prototype.slice.call(faq.querySelectorAll('[data-sshp-item]'));
    var empty = faq.querySelector('[data-sshp-empty]');
    var countEl = faq.querySelector('[data-sshp-count]');
    var moreBtn = faq.querySelector('[data-sshp-more]');
    var clearEls = Array.prototype.slice.call(document.querySelectorAll('[data-sshp-clear]'));

    var cap = parseInt(faq.getAttribute('data-cap'), 10) || 8;
    var topic = 'all';
    var expanded = false;

    /* Each chip says how many answers sit behind it. Counted once from
       the blocks, so it cannot drift from what is actually there. */
    topics.forEach(function (btn) {
      var t = btn.getAttribute('data-sshp-topic');
      var slot = btn.querySelector('[data-sshp-topic-count]');
      if (!slot) return;
      slot.textContent = String(
        t === 'all' ? items.length : items.filter(function (i) {
          return i.getAttribute('data-topic') === t;
        }).length
      );
    });

    function query() {
      for (var i = 0; i < inputs.length; i++) {
        var v = (inputs[i].value || '').trim().toLowerCase();
        if (v) return v;
      }
      return '';
    }

    function apply() {
      var q = query();
      var narrowed = q !== '' || topic !== 'all';
      var matched = items.filter(function (item) {
        var okTopic = topic === 'all' || item.getAttribute('data-topic') === topic;
        var okQuery = !q || (item.textContent || '').toLowerCase().indexOf(q) !== -1;
        return okTopic && okQuery;
      });

      var limit = (narrowed || expanded) ? matched.length : Math.min(cap, matched.length);
      items.forEach(function (item) {
        item.hidden = true;
      });
      matched.slice(0, limit).forEach(function (item) {
        item.hidden = false;
      });

      if (countEl) {
        countEl.textContent = matched.length + (matched.length === 1 ? ' answer' : ' answers');
      }
      if (empty) empty.hidden = matched.length !== 0;

      if (moreBtn) {
        var hidden = matched.length - limit;
        var show = hidden > 0 || (expanded && !narrowed && matched.length > cap);
        moreBtn.hidden = !show;
        /* [n] not {n} - a brace inside a Liquid argument breaks the
           parser, so the token in the setting is square brackets and
           the two must agree. */
        moreBtn.textContent = hidden > 0
          ? (moreBtn.getAttribute('data-more') || 'Show all [n] questions').replace('[n]', matched.length)
          : (moreBtn.getAttribute('data-less') || 'Show fewer');
      }

      clearEls.forEach(function (el) { el.hidden = q === ''; });
    }

    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        expanded = false;
        apply();
      });
    });

    clearEls.forEach(function (el) {
      el.addEventListener('click', function () {
        inputs.forEach(function (i) { i.value = ''; });
        expanded = false;
        apply();
      });
    });

    topics.forEach(function (btn) {
      btn.addEventListener('click', function () {
        topic = btn.getAttribute('data-sshp-topic');
        expanded = false;
        topics.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        expanded = !expanded;
        apply();
      });
    }

    apply();
  }

  function initContactForm(root) {
    /* Submit the Shopify contact form over fetch and swap in the
       success card - no full page reload. Falls back to a native
       submit on network errors or a spam-challenge redirect. */
    root.querySelectorAll('form.sshp-contact__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        var btn = form.querySelector('.sshp-contact__submit');
        var label = btn ? btn.textContent : '';
        if (btn) {
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-sending') || label;
        }
        fetch(form.getAttribute('action') || '/contact', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' }
        })
          .then(function (res) {
            if (res.ok && res.url.indexOf('challenge') === -1) {
              var wrap = form.closest('[data-sshp-contact]');
              var success = wrap && wrap.querySelector('[data-sshp-success]');
              form.hidden = true;
              if (success) {
                success.hidden = false;
                success.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            } else {
              if (btn) { btn.disabled = false; btn.textContent = label; }
              form.submit();
            }
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
            form.submit();
          });
      });
    });
  }

  function scrollToResult(root) {
    /* After the contact form posts (success or errors) the page reloads
       at the top - bring the visitor back to the contact section. */
    var flag = root.querySelector('[data-sshp-posted]');
    if (!flag) return;
    setTimeout(function () {
      var target = root.querySelector('#contact') || flag;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
  }

  function init(root) {
    if (!root || root.dataset.sshpInit === '1') return;
    root.dataset.sshpInit = '1';
    initTabs(root);
    initVideos(root);
    initAccordions(root);
    initFaqFilter(root);
    initContactForm(root);
    scrollToResult(root);
  }

  function boot() {
    document.querySelectorAll('.sshp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('.sshp');
    if (root) init(root);
  });
})();
